import React, { useRef } from 'react';
import PEHeroSection from '../../../components/landingPage/PEPage/PEHeroSection';
import PEPartnershipStrip from '../../../components/landingPage/PEPage/PEPartnershipStrip';
import PEThesisStatement from '../../../components/landingPage/PEPage/PEThesisStatement';
import PECombinedServices from '../../../components/landingPage/PEPage/PECombinedServices';
import PEResourcesSection from '../../../components/landingPage/PEPage/PEResourcesSection';
import PEWhySection from '../../../components/landingPage/PEPage/PEWhySection';
import PELifecycleSection from '../../../components/landingPage/PEPage/PELifecycleSection';
import PEInvestorMatchSection from '../../../components/landingPage/PEPage/PEInvestorMatchSection';
import PECtaSection from '../../../components/landingPage/PEPage/PECtaSection';
import { useReveal, useCountUp } from '../../../components/landingPage/common/landingHooks';

const LandingHomePEs = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);

    return (
        <div className="lp-page lp-pe-page" ref={rootRef}>
            <PEHeroSection />
            <PEPartnershipStrip />
            <PEThesisStatement />
            <PECombinedServices />
            <PEResourcesSection />
            <PEWhySection />
            <PELifecycleSection />
            <PEInvestorMatchSection />
            <PECtaSection />
        </div>
    );
};

export default LandingHomePEs;
